import React, { RefObject, useContext } from 'react';
import { Box, Portal, PortalProps } from '@chakra-ui/react';

export const AppOverlayPortalContext = React.createContext<
  RefObject<HTMLDivElement | null> | undefined
>(undefined);

export const AppOverlayPortal: React.FC<PortalProps> = ({
  children,
  ...props
}) => {
  const overlayContainerRef = useContext(AppOverlayPortalContext);
  return (
    <Portal containerRef={overlayContainerRef} {...props}>
      {children}
    </Portal>
  );
};

export const AppOverlayPortalContainer = React.forwardRef<HTMLDivElement>(
  (props, ref) => (
    <Box position="absolute" inset={0} width="100%" height="100%" ref={ref} />
  )
);
